import { Directive, Input, HostBinding } from '@angular/core';
import { convertHexToRgba } from 'src/shared/helpers/color-helpers';

/**
 * Директива для создания полупрозрачного цвета фона элемента
 * @package BackgroundColorOpacityDirective
 * @version 1.0
 * @author Dogaeva A.P.
 * @copyright (c) Internet-Frigate {@link http://www.ifrigate.ru}
 */

@Directive({
    selector: '[backgroundOpacityColor]',
    standalone: true,
})
export class BackgroundColorOpacityDirective {
    /** Основной цвет - формат hex */
    @Input('backgroundOpacityColor') public mainColor: string;
    /** Процент непрозрачности */
    @Input() opacityAmount?: number = 50;

    @HostBinding('style.backgroundColor')
    get backgroundColor(): string {
        if (this.mainColor && this.opacityAmount) {
            return convertHexToRgba(this.mainColor, this.opacityAmount);
        } else {
            return this.mainColor;
        }
    }
}
